import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "cursor-default mb-3" }
const _hoisted_3 = {
  for: "feed-url",
  class: "mb-2"
}
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  for: "feed-folder",
  class: "mb-2 mt-3"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "d-flex flex-column gap-1" }
const _hoisted_10 = ["aria-checked", "onClick"]
const _hoisted_11 = { class: "text-truncate" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "c-spinner"
}
const _hoisted_14 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toast = _resolveComponent("v-toast")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t("new_feed")), 1 /* TEXT */)
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.createFeed($event)), ["prevent"])),
      class: "d-flex flex-column"
    }, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("url")), 1 /* TEXT */),
      _withDirectives(_createElementVNode("input", {
        id: "feed-url",
        name: "url",
        type: "url",
        class: "c-input",
        required: "",
        autocomplete: "off",
        readonly: _ctx.feedNewChoice.length > 0,
        placeholder: "https://example.com/feed"
      }, null, 8 /* PROPS */, _hoisted_4), [
        [_directive_focus]
      ]),
      _createElementVNode("label", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$t("folder")) + " ", 1 /* TEXT */),
        _createElementVNode("a", {
          href: "#",
          class: "float-end text-decoration-none",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.createNewFeedFolder()), ["prevent"]))
        }, _toDisplayString(_ctx.$t("new_folder")), 1 /* TEXT */)
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "c-input",
        id: "feed-folder",
        name: "folder_id",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectedFolder) = $event))
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "---", -1 /* CACHED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder) => {
          return (_openBlock(), _createElementBlock("option", {
            value: folder.id
          }, _toDisplayString(folder.title), 9 /* TEXT, PROPS */, _hoisted_6))
        }), 256 /* UNKEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vModelSelect, _ctx.selectedFolder]
      ]),
      (_ctx.feedNewChoice.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("multiple_feeds_found")) + " ", 1 /* TEXT */),
              _createElementVNode("a", {
                href: "#",
                class: "float-end text-decoration-none",
                onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.resetFeedChoice()), ["prevent"]))
              }, _toDisplayString(_ctx.$t("cancel")), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedNewChoice, (choice) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "c-listitem d-flex flex-column user-select-none",
                  role: "radio",
                  "aria-checked": _ctx.feedNewChoiceSelected === choice.url,
                  onClick: $event => (_ctx.feedNewChoiceSelected = choice.url)
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(choice.title), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-truncate", { 'opacity-50': choice.title }])
                  }, _toDisplayString(choice.url), 3 /* TEXT, CLASS */)
                ], 8 /* PROPS */, _hoisted_10))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        class: "c-button mt-3",
        disabled: _ctx.loading.newfeed,
        type: "submit"
      }, [
        (_ctx.loading.newfeed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("add")), 1 /* TEXT */))
      ], 8 /* PROPS */, _hoisted_12)
    ], 32 /* NEED_HYDRATION */),
    _createVNode(_component_v_toast, { ref: "toast" }, null, 512 /* NEED_PATCH */)
  ]))
}